import React from "react";
import styled, { css } from "styled-components";

import {
  BasicModal,
  BasicModalProps
} from "src/library/components/Modal";
import { Text } from "src/library/components/Text";
import { Button } from "src/library/components/Button";

export interface CloseTicketWithCreditsModelProps extends Pick<BasicModalProps, "onDismiss" | "open"> {
  onConfirm: () => void;
}

export const CloseTicketWithCreditsModel: React.ReactFCWithChildren<CloseTicketWithCreditsModelProps> = ({
  onDismiss, open, onConfirm
}) => {
  return (
    <StyledBasicModal
      title="Cancel Credit Request"
      open={open}
      onDismiss={() => onDismiss()}
    >

      <Text as="p">
        You are about to cancel this credit request. This will close this ticket and revert the approved quantities to 0.
      </Text>

      <Text as="p">
        Please confirm you would like to cancel this request.
      </Text>

      <div className="action-buttons">
        <Button
          onClick={() => onDismiss()}
          $buttonType="secondary"
        >
          Cancel
        </Button>

        <Button onClick={() => onConfirm()}>
          Confirm
        </Button>
      </div>

    </StyledBasicModal>
  );
};

const StyledBasicModal = styled(BasicModal)`
  ${({ theme }) => css`    
    .action-buttons {
      display: flex;
      justify-content: space-between;
      margin-top: ${theme.spacing.margins.md};
    }

    .loading-container {
      width: 100%;
    }
  `}
`;
